export default {
  // Título del panel
  title: 'Diagnostics',

  // Log tracker (consola y peticiones HTTP)
  logTracker: 'Log tracker',
  logTrackerHint: 'Console and HTTP requests inside the app',

  // Modo QA offline
  qaMode: 'Offline QA mode',
  qaModeHint: 'Verbose logger and sync banner always visible',

  // Copiar info de diagnóstico
  copyEnv: 'Copy diagnostics info',
  envCopied: 'Diagnostics info copied',
  copyFailed: 'Could not copy',

  // Capa offline — estado y detalle tecnico
  offlineTitle: 'Offline layer',
  offlineDbOk: 'Database is open',
  offlineDbFail: 'Database did NOT open',
  offlineDbFailHint: 'Report this to support: the app cannot save while offline',
  offlineUnavailable: 'Status not available',
  offlinePlatform: 'Platform',
  offlineBackend: 'Database engine',
  offlineSqlitePlugin: 'SQLite plugin',
  offlineFilesystem: 'Filesystem plugin',
  offlineDebugEnabled: 'Debug log',
  offlineFlag: 'Offline mode active',
  offlineLogEntries: 'Log entries',

  // Valores genericos de la tabla de diagnostico
  yes: 'Yes',
  no: 'No',
  empty: 'No data'
}
